import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { persistCajeroSession, persistTerminalSession } from '../hooks/useSucursal';
import SucursalSelector from '../components/SucursalSelector';
import './LoginPage.css';
import ErpImage from '../assets/erpLogin.jpg';

const LoginPage = () => {
    const [email, setEmail]       = useState('');
    const [password, setPassword] = useState('');
    const [error, setError]       = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [pendingRotatingLogin, setPendingRotatingLogin] = useState(null);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const response = await authAPI.login({ email, password });
            const { tipo, token } = response.data.data;

            if (!token) throw new Error('El token no fue recibido del servidor.');

            // ── CASO 1: Trabajador (Cajera / Encargada de Sucursal) ──
            if (tipo === 'cajero') {
                const { empleado, sucursal, user, sucursales_permitidas, es_rotativo } = response.data.data;
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(user));

                // Si es cajero rotativo (múltiples sucursales asignadas), seleccionar a cuál entra hoy
                if (es_rotativo && sucursales_permitidas && sucursales_permitidas.length > 1) {
                    setPendingRotatingLogin(response.data.data);
                    return;
                }

                persistCajeroSession({
                    ...empleado,
                    sucursal_id: sucursal.id,
                    sucursal_nombre: sucursal.nombre,
                    es_offline: sucursal.es_offline,
                    modules: sucursal.modules,
                    sucursales_permitidas: sucursales_permitidas || [sucursal]
                });

                navigate('/sales');
                return;
            }

            // ── CASO 2: Modo Terminal / Kiosco (Retrocompatibilidad por código de sucursal) ──
            if (tipo === 'terminal') {
                const { sucursal } = response.data.data;
                localStorage.setItem('token', token);

                const profileRes = await authAPI.getProfile();
                const tenantUser = profileRes.data.data.user || profileRes.data.data;
                localStorage.setItem('user', JSON.stringify(tenantUser));

                persistTerminalSession(sucursal);
                navigate('/sales');
                return;
            }

            // ── CASO 3: Dueño o SuperAdmin ──────────────────────────────────
            const { user } = response.data.data;

            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('cuenta_tipo', 'admin');

            if (user.role === 'superadmin') {
                navigate('/admin');
                return;
            }

            // Dueño → dashboard (vista de control total)
            navigate('/dashboard');

        } catch (err) {
            console.error('Error de login:', err);
            const message = err.response?.data?.message || 'Credenciales incorrectas o error de conexión.';
            setError(message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-page-container">
            <div className="login-card">
                <div className="login-image-section">
                    <img
                        src={ErpImage}
                        alt="ERP System Illustration"
                    />
                </div>
                <div className="login-form-section">
                    <h2>Iniciar Sesión</h2>
                    <p style={{ color: '#64748b', fontSize: 14, marginBottom: 20 }}>
                        Ingresa tus datos para acceder al sistema
                    </p>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="email">Usuario o Correo</label>
                            <input
                                type="text"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Ej: alex o maria_cusco"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Contraseña</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Ingresa tu contraseña"
                                required
                            />
                        </div>
                        <button type="submit" className="login-button" disabled={isLoading}>
                            {isLoading ? 'Iniciando...' : 'Entrar al Sistema'}
                        </button>
                        {error && <p className="error-message">{error}</p>}
                    </form>
                </div>
            </div>

            {pendingRotatingLogin && (
                <SucursalSelector
                    sucursales={pendingRotatingLogin.sucursales_permitidas}
                    businessName={pendingRotatingLogin.user?.business_name || 'Mi Negocio'}
                    onSelect={(selectedSucursal) => {
                        const { empleado, sucursales_permitidas } = pendingRotatingLogin;
                        persistCajeroSession({
                            ...empleado,
                            sucursal_id: selectedSucursal.id,
                            sucursal_nombre: selectedSucursal.nombre,
                            es_offline: selectedSucursal.es_offline,
                            modules: selectedSucursal.modules,
                            sucursales_permitidas: sucursales_permitidas
                        });
                        navigate('/sales');
                    }}
                />
            )}
        </div>
    );
};

export default LoginPage;